import React, { useState, useEffect } from 'react';
//import {useLocation } from 'react-router-dom';

import "../Pagina.css";

import parse from 'html-react-parser';

import { language } from '../WEBContent/Language';

import {
    set_language,

} from '../../../Utils';

import CookieConsent from "react-cookie-consent";

import * as Hosts from "../../../Hosts";


const Cookies = (props) => {

    const [template, set_template] = useState('');
    const [theme, set_theme] = useState('');
    const [avaiable, set_avaiable] = useState(false);

    const [lang, set_lang] = useState('pt');

    

    //const page_location = useLocation().pathname.split('/').pop();

    useEffect(() => {

        if(props.item !== undefined && props.item !== null && props.item !== '') {
            set_template(props.item.template)
            set_theme(props.item.theme)
            set_avaiable(props.item.dados_config.info.avaiable)
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props])

    return (

        avaiable ? 
            <div className={template + ' ' + theme}>
                <CookieConsent
                    /*debug={true}*/
                    ariaAcceptLabel={language[lang].cookie_button_text}
                    buttonText={language[lang].cookie_button_text}
                    buttonClasses={"btn-cookies"}
                    containerClasses="containerCookie"
                    contentClasses="messageCookie"
                >
                    <a className="sr-only sr-only-focusable" href="#navbar">Skip to main content</a>
                    <div className="col-12 text-center">
                        {parse(language[lang].cookies_message)}&nbsp;
                        <a href={Hosts.WEB_SITE_URI + "terms-conditions"}>{language[lang].more_information}</a>
                    </div>
                </CookieConsent>
            </div >
        :
            null
    )
};
export default Cookies;